// src/components/financeOfficer/CreateRequisitionModal.jsx

import React from 'react';
import CreateRequisitionForm from "./CreateRequisitionForm";

const CreateRequisitionModal = ({ onClose, onSubmit }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg mx-4">
                <div className="flex justify-end p-2">
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        
                    </button>

                </div>
                <CreateRequisitionForm 
                    onSubmit={onSubmit} 
                    onClose={onClose}
                />
            </div>
        </div>
    );
};

export default CreateRequisitionModal;